"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountdownTimer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _CountdownTimer = require("./CountdownTimer.styled");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
var CountdownTimer = exports.CountdownTimer = function CountdownTimer(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'default' : _ref$color,
    text = _ref.text,
    duration = _ref.duration;
  return /*#__PURE__*/_react["default"].createElement(_CountdownTimer.StyledAlert, {
    "data-testId": "countdown-timer-alert",
    color: color
  }, /*#__PURE__*/_react["default"].createElement(_CountdownTimer.StyledAlertText, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeRegularSvgIcons.faClock
  }), text && /*#__PURE__*/_react["default"].createElement("span", {
    className: "text"
  }, text, ":")), duration && /*#__PURE__*/_react["default"].createElement("div", {
    className: "duration"
  }, duration));
};
CountdownTimer.propTypes = {
  color: (0, _propTypes.oneOf)(['default', 'info', 'warning', 'alert', 'success', 'dark']),
  text: _propTypes.string.isRequired,
  duration: _propTypes.string.isRequired
};